import React, { Component } from "react"
import { Icon, Affix, Menu, Select } from "antd"
import { observer, inject } from "mobx-react"

const { Option, OptGroup } = Select

@inject("auth", "store") @observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dayKey: "-1",
    }
  }

  closeModal = (modal) => {
    this.setState({
      [modal]: false
    })
  }

  onDayChange = (e) => {
    const {
      list: { filterData },
      filterCharData
    } = this.props.store
    const dateParamsMap = new Map([
      ['-1', { tab: 'month', option: 0 }],
      ['w_1', { tab: 'week', option: 1 }],
      ['w_2', { tab: 'week', option: 2 }],
      ['m_0', { tab: 'month', option: 0 }],
      ['m_1', { tab: 'month', option: 1 }],
      ['m_2', { tab: 'month', option: 2 }],
      ['q_0', { tab: 'quarter', option: 0 }],
      ['q_1', { tab: 'quarter', option: 1 }],
      ['q_2', { tab: 'quarter', option: 2 }],
      ['y_0', { tab: 'year', option: 0 }],
      ['y_1', { tab: 'year', option: 1 }],
      ['y_2', { tab: 'year', option: 2 }],
    ])
    filterData(dateParamsMap.get(e))
    filterCharData(dateParamsMap.get(e))
  }

  render() {
    const dateGroupOptions = [{
      label: '按周选择',
      options: [{ label: '上周', value: 'w_1' }, { label: '上上周', value: 'w_2' }]
    },
    {
      label: '按月选择',
      options: [{ label: '本月', value: 'm_0' }, { label: '上月', value: 'm_1' }, { label: '上上月', value: 'm_2' }]
    }, {
      label: '按季选择',
      options: [{ label: '本季', value: 'q_0' }, { label: '上季', value: 'q_1' }, { label: '上上季', value: 'q_2' }]
    },
    {
      label: '按年选择',
      options: [{ label: '本年', value: 'y_0' }, { label: '上年', value: 'y_1' }]
    }]
    return (
      <Affix
        className="affix-head"
        target={() => document.getElementsByClassName("salt-pagelayout")[0]} offsetTop={50}
      >
        <div className="affix-back">
          <div className="statistics-select-bar">
            <div className='select-bar-wrap'>
              <Menu className="menu-day" onClick={e => this.onDayChange(e.key)}
                selectedKeys={[this.state.dayKey]}
                mode="horizontal"
                key="menu_date_0"
              >
                <Menu.Item key="-1">
                  <Icon type="calendar" />全部
              </Menu.Item>
              </Menu>
              <Select
                className='select-day'
                defaultValue="m_0"
                onChange={e => this.onDayChange(e)}
              >
                {dateGroupOptions.map((group, index) =>
                  (
                    <OptGroup label={group.label} key={index}>
                      {group.options.map((option, index) => (
                        <Option key={index} value={option.value}>{option.label}</Option>
                      ))}
                    </OptGroup>
                  )
                )}
              </Select>
            </div>
          </div>
        </div>
      </Affix>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/preview/bill/containers/DataHeader.js